import React, { useState, useRef, useEffect } from "react";
import { Calendar, Search, ChevronDown, ChevronUp } from "lucide-react";
import {
  handleError,
  handleSuccess,
  handleSuccessSession,
  handleSuccessShow,
} from "../../CommonJquery/CommonJquery";
import {
  server_post_data,
  get_booking_data_by_driver,
  save_service_charge_amount_payment,
} from "../../ServiceConnection/serviceconnection";
import DummyDriver from "../../assets/dummyDriver.jpeg";
import Loader from "../Loader";

const UpdateCharges = ({
  activeSection,
  driverData,
  master_data_getDriverData,
  master_data_get,
  selectedDriverId,
  selectedDriverBookingId,
  startDateAll,
  endDateAll,
  dateRangeType,
}) => {
  // Use current date without allowing selection
  const [currentDate] = useState(new Date());
  const [driverDatasingle, setDriverDataSingle] = useState(null);
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [bookingData, setBookingData] = useState([]);
  const [tollCharge, setTollCharges] = useState(0);
  const [damageCharge, setdamageCharges] = useState(0);
  const [TicketCharge, setTicketCharges] = useState(0);
  const [otherCharge, setotherCharges] = useState(0);
  const [notes, setnotes] = useState("");
  const [bookingType, setbookingType] = useState("1");
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [isDriverDropdownOpen, setIsDriverDropdownOpen] = useState(false);
  const [driverSearchQuery, setDriverSearchQuery] = useState("");
  const driverDropdownRef = useRef(null);

  useEffect(() => {
    // Close dropdown when clicking outside
    const handleClickOutside = (event) => {
      if (
        driverDropdownRef.current &&
        !driverDropdownRef.current.contains(event.target)
      ) {
        setIsDriverDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleSelectDriver = (driver) => {
    setSelectedDriver(driver);
    // console.log(driver);
    setDriverDataSingle(driver);
    setIsDriverDropdownOpen(false);
    setDriverSearchQuery("");
    handleDateChange(driver);
  };

  // Filter drivers based on search query
  const filteredDrivers = driverData
    ? driverData.filter(
        (driver) =>
          (driver.name ? driver.name.toLowerCase() : "").includes(
            driverSearchQuery.toLowerCase()
          ) ||
          (driver.primary_id
            ? driver.primary_id.toString().toLowerCase()
            : ""
          ).includes(driverSearchQuery.toLowerCase())
      )
    : [];

  //console.log("driverSearchQuery", driverSearchQuery);

  const handleDateChange = async (data) => {
    if (data === null) return;
    setDriverDataSingle(data);
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("booking_id", data.primary_id);
    await server_post_data(get_booking_data_by_driver, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setBookingData(Response.data.message.booking_data);
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  function formatDate(dateObj) {
    // console.log(dateObj);
    const year = dateObj.getFullYear();
    const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
    const day = dateObj.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  // Format today's date for display
  const formattedCurrentDate = `${(currentDate.getMonth() + 1)
    .toString()
    .padStart(2, "0")}/${currentDate
    .getDate()
    .toString()
    .padStart(2, "0")}/${currentDate.getFullYear()}`;

  const handleSave = async () => {
    if (driverDatasingle == null) {
      alert("select Driver");
      return;
    }
    const totalCharges =
      parseFloat(tollCharge || 0) +
      parseFloat(TicketCharge || 0) +
      parseFloat(otherCharge || 0) +
      parseFloat(damageCharge || 0);

    if (totalCharges <= 0) {
      alert("Total charges must be greater than zero.");
      return;
    }

    // if (!bookingType) {
    //   alert("Please select booking type.");
    //   return;
    // }

    setshowLoaderAdmin(true);
    const fd = new FormData();

    if (bookingType == "1") {
      fd.append("booking_id", selectedDriver?.booking_data?.primary_id);
      fd.append("car_id", driverDatasingle?.booking_data?.car_id);
      fd.append("contract_id", driverDatasingle?.booking_data?.contract_id);
    }
    if (bookingType == "2") {
      fd.append("booking_id", selectedDriver?.old_booking_data?.primary_id);
      fd.append("car_id", driverDatasingle?.old_booking_data?.car_id);
      fd.append("contract_id", driverDatasingle?.old_booking_data?.contract_id);
    }
    fd.append("user_id", driverDatasingle.primary_id);
    fd.append("booking_type", bookingType);
    fd.append("tollCharge", tollCharge);
    fd.append("TicketCharge", TicketCharge);
    fd.append("otherCharge", otherCharge);
    fd.append("damageCharge", damageCharge);
    fd.append("notes", notes);
    fd.append("discountDate", formatDate(currentDate));
    await server_post_data(save_service_charge_amount_payment, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setbookingType("");
          setTicketCharges("");
          setdamageCharges("");
          setotherCharges("");
          setTollCharges("");
          setnotes("");
          handleSuccessShow("Successfully Saved!");
          master_data_getDriverData();
          master_data_get(
            startDateAll,
            endDateAll,
            2,
            dateRangeType,
            selectedDriverId,
            selectedDriverBookingId
          );
          setSelectedDriver(null);
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  const handleChargeChange = (e, setter) => {
    const value = e?.target?.value;
    if (value === undefined) return;
    if (parseFloat(value) < 0) {
      alert("Rent cannot be negative");
      return;
    } else {
      setter(value);
    }
  };

  return (
    <>
      {showLoaderAdmin && <Loader />}
      <section
        id="update-charges"
        className={`accounting-section ${
          activeSection === "update-charges" ? "" : "accounting-hidden"
        }`}
      >
        <div className="accounting-charges-container">
          <div className="accounting-charges-header">
            <h2 className="accounting-charges-title">Update Charges</h2>
            <p className="accounting-charges-subtitle">
              Add or edit damage, tickets, and other charges
            </p>
          </div>

          <div className="accounting-charges-content">
            <div className="accounting-charges-form">
              <div className="accounting-charges-fields">
                <div className="accounting-charges-field">
                  <label htmlFor="charge-date" className="accounting-label">
                    Date
                  </label>
                  <div className="accounting-date-input-wrapper">
                    <input
                      id="current-date"
                      className="accounting-date-input borderRadiusnew mt-0"
                      value={formattedCurrentDate}
                      readOnly
                      disabled
                    />
                    <Calendar className="accounting-date-icon" size={18} />
                  </div>
                </div>

                {/* <div className="accounting-payment-field">
                  <label htmlFor="payment-mode" className="accounting-label">
                    Booking Type
                  </label>
                  <select
                    id="payment-mode"
                    name="payment-mode"
                    className="accounting-select"
                    value={bookingType}
                    onChange={(e) => setbookingType(e.target.value)}
                  >
                    <option value="" disabled hidden>
                      Select Booking Type
                    </option>
                    <option value="1">Active</option>
                    <option value="2">Dropped</option>
                  </select>
                </div> */}

                <div className="accounting-charges-field">
                  <label htmlFor="driver-select" className="accounting-label">
                    Select Driver
                  </label>
                  <div className="position-relative" ref={driverDropdownRef}>
                    <div
                      className="form-floating form-control shadow-sm d-flex justify-content-between align-items-center cursor-pointer"
                      onClick={() =>
                        setIsDriverDropdownOpen(!isDriverDropdownOpen)
                      }
                      style={{
                        cursor: "pointer",
                        height: "40px",
                        paddingTop: "10px",
                        marginTop: "6px",
                      }}
                    >
                      {selectedDriver ? (
                        <div className="fw-medium">{selectedDriver.name}</div>
                      ) : (
                        <div className="">Choose a driver</div>
                      )}
                      <div
                        className="position-absolute"
                        style={{
                          bottom: "6px",
                          right: "10px",
                          pointerEvents: "none",
                        }}
                      >
                        {isDriverDropdownOpen ? (
                          <ChevronUp size={16} />
                        ) : (
                          <ChevronDown size={16} />
                        )}
                      </div>
                    </div>

                    {isDriverDropdownOpen && (
                      <div
                        className="position-absolute w-100 bg-white shadow-lg rounded-bottom z-index-1000"
                        style={{ zIndex: 1000 }}
                      >
                        <div className="p-2 border-bottom">
                          <div className="input-group">
                            <span
                              className="input-group-text bg-white border-end-0"
                              style={{ marginTop: "5px" }}
                            >
                              <Search size={16} />
                            </span>
                            <input
                              type="text"
                              className="form-control border-start-0"
                              placeholder="Search by name or ID..."
                              value={driverSearchQuery}
                              onChange={(e) =>
                                setDriverSearchQuery(e.target.value)
                              }
                              autoFocus
                            />
                          </div>
                        </div>
                        <div style={{ maxHeight: "250px", overflowY: "auto" }}>
                          {driverData && driverData.length > 0 ? (
                            filteredDrivers.map((driver) => (
                              <div
                                key={driver.primary_id}
                                className="p-2 border-bottom hover-bg-light cursor-pointer"
                                // onClick={() => handleSelectDriver(driver)}
                                onClick={() => {
                                  const booking = driver?.booking_data;
                                  console.log("mk", booking);

                                  if (!booking) {
                                    alert("This driver has no booking.");
                                    setSelectedDriver(null);
                                    return;
                                  }

                                  const step = booking.step_for_booking;
                                  const switchType =
                                    booking.payment_cycle_switch;

                                  if (
                                    step === "5" &&
                                    ["1", "2", "3"].includes(switchType)
                                  ) {
                                    alert(
                                      "This driver has no active booking. The last booking was a switched booking."
                                    );
                                    setSelectedDriver(null);
                                    return;
                                  }

                                  if (step === "6") {
                                    alert(
                                      "Please complete the last booking switch process before continuing."
                                    );
                                    setSelectedDriver(null);
                                    return;
                                  }

                                  if (step === "7") {
                                    alert(
                                      "Please complete the last booking repo process before continuing."
                                    );
                                    setSelectedDriver(null);
                                    return;
                                  }

                                  if (["0", "1", "2", "3"].includes(step)) {
                                    alert(
                                      "This driver has a booking in progress but it is not active yet."
                                    );
                                    setSelectedDriver(null);
                                    return;
                                  }

                                  if (["9", "10"].includes(step)) {
                                    alert(
                                      "The last booking was either rejected or canceled."
                                    );
                                    setSelectedDriver(null);
                                    return;
                                  }

                                  handleSelectDriver(driver);
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                <div className="fw-medium">{driver.name}</div>
                                <div className="small text-muted">
                                  ID: {driver.primary_id}
                                </div>
                              </div>
                            ))
                          ) : (
                            <div className="p-3 text-center text-muted">
                              No drivers found
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="accounting-charges-list">
                <h3 className="accounting-charges-list-title">
                  Service Charges ($)
                </h3>

                <div className="accounting-charge-item">
                  <div className="accounting-charge-name">
                    <label className="accounting-charge-label">
                      <span>Tolls ($)</span>
                    </label>
                  </div>
                  <div className="accounting-charge-amount">
                    <input
                      type="number"
                      id="tolls"
                      name="tolls"
                      placeholder="Amount ($)"
                      className="accounting-input"
                      value={tollCharge}
                      onChange={(e) => handleChargeChange(e, setTollCharges)}
                    />
                  </div>
                </div>

                <div className="accounting-charge-item">
                  <div className="accounting-charge-name">
                    <label className="accounting-charge-label">
                      <span>Damage ($)</span>
                    </label>
                  </div>
                  <div className="accounting-charge-amount">
                    <input
                      type="number"
                      id="damage"
                      name="damage"
                      placeholder="Amount ($)"
                      className="accounting-input"
                      value={damageCharge}
                      onChange={(e) => handleChargeChange(e, setdamageCharges)}
                    />
                  </div>
                </div>

                <div className="accounting-charge-item">
                  <div className="accounting-charge-name">
                    <label className="accounting-charge-label">
                      <span>Ticket ($)</span>
                    </label>
                  </div>
                  <div className="accounting-charge-amount">
                    <input
                      type="number"
                      id="tickets"
                      name="tickets"
                      placeholder="Amount ($)"
                      className="accounting-input"
                      value={TicketCharge}
                      onChange={(e) => handleChargeChange(e, setTicketCharges)}
                    />
                  </div>
                </div>

                <div className="accounting-charge-item">
                  <div className="accounting-charge-name">
                    <label className="accounting-charge-label">
                      <span>Other Charge ($)</span>
                    </label>
                  </div>
                  <div className="accounting-charge-amount">
                    <input
                      type="number"
                      id="otherCharge"
                      name="otherCharge"
                      placeholder="Amount ($)"
                      className="accounting-input"
                      value={otherCharge}
                      onChange={(e) => handleChargeChange(e, setotherCharges)}
                    />
                  </div>
                </div>
              </div>

              <div className="accounting-charges-notes">
                <label htmlFor="notes" className="accounting-label">
                  Notes (Optional)
                </label>
                <textarea
                  id="notes"
                  rows="3"
                  className="accounting-textarea"
                  placeholder="Add any additional information about these charges"
                  defaultValue={notes}
                  onChange={(e) => setnotes(e.target.value)}
                ></textarea>
              </div>

              <div className="accounting-charges-actions">
                <button
                  type="button"
                  className={`accounting-btn accounting-btn-primary ${
                    bookingType == "2" &&
                    selectedDriver?.old_booking_data?.payment_cycle_switch !=
                      "0" &&
                    "disabledBtnPayment"
                  }`}
                  onClick={handleSave}
                >
                  Update Charges
                </button>
              </div>
            </div>

            <div className="accounting-charges-sidebar">
              <div className="accounting-info-card accounting-info-card-blue">
                <h4 className="accounting-info-title">Important Note</h4>
                <p className="accounting-info-text">
                  These charges will be added to the driver's ledger as dues. No
                  payment is recorded with this form.
                </p>
              </div>

              <div className="accounting-info-card accounting-info-card-amber">
                <h4 className="accounting-info-title">Driver Impact</h4>
                <p className="accounting-info-text">
                  Remember to notify the driver when adding new charges to
                  maintain transparent communication.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default UpdateCharges;
